import React, { useState, useRef } from "react";
import "./dynamic_card.css";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Navigation, Pagination } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/navigation";
import "swiper/css/pagination";

function DynamicCard({ cardsData }) {
  const [selectedCard, setSelectedCard] = useState(null);
  const swiperRef = useRef(null);

  const closeModal = () => setSelectedCard(null);

  // Helper to get file URLs for images/videos
  const getFileUrl = (card, filename) => {
    if (!filename) return null;
    return `/Gallery_page_images/${card.year}/${filename}`;
  };

  // Swiper settings
  const settings = {
    effect: "coverflow",
    grabCursor: true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
    navigation: true,
    pagination: { clickable: true },
    modules: [EffectCoverflow, Autoplay, Navigation, Pagination],
    style: { width: "100%", height: "85%" },
    onSwiper: (swiper) => {
      swiperRef.current = swiper;
    },
  };

  // Normalize selected card
  const handleSelectCard = (card) => {
    setSelectedCard({
      ...card,
      video: card.video ? [card.video] : [],   // Always array
      images: card.images
        ? Array.isArray(card.images)
          ? card.images
          : [card.images]
        : [],
    });
  };

  return (
    <>
      <div className="card-container">
        {cardsData.map((card) => (
          <div key={card.id} className="card" onClick={() => handleSelectCard(card)}>
            <img src={getFileUrl(card, card.tab_image)} alt={card.title} />
            <h3>{card.title}</h3>
          </div>
        ))}
      </div>

      {selectedCard && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>✖</button>
            <h2>{selectedCard.title}</h2>

            <Swiper {...settings}>
              {/* Render videos */}
              {selectedCard.video.map((videoFile, idx) => (
                <SwiperSlide key={"video-" + idx}>
                  <video
                    src={getFileUrl(selectedCard, videoFile)}
                    controls
                    autoPlay
                    muted
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "12px",
                    }}
                  />
                </SwiperSlide>
              ))}

              {/* Render images */}
              {selectedCard.images.map((img, idx) => (
                <SwiperSlide key={"img-" + idx}>
                  <img
                    src={getFileUrl(selectedCard, img)}
                    alt={`Slide ${idx + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "12px",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
}

export default DynamicCard;
